import { useActionData } from "react-router-dom";

import TaggedText from "components/TaggedText";
import { RouteErrors } from "routes/data-routes/types";


/**
 * Usually called with data coming from fetcher.data. It's safe to assume that `data` here is always an object as
 * React Router will parse that even if loaders or actions returned a Response.
 *
 * @param data  Either an IRouterActionError object or a plain ActionError object, usually returned by a loader or an action.
 */
export default function useFormattedActionError(data?: RouteErrors.RouterActionError | RouteErrors.ActionError): string | JSX.Element | undefined {
  const actionData = useActionData() as RouteErrors.RouterActionError;
  const errorData: RouteErrors.ActionError | undefined = (data as RouteErrors.RouterActionError)?.error ?? (data as RouteErrors.ActionError) ?? actionData?.error;

  if (errorData?.taggedMessage) {
    return <TaggedText message={ errorData.taggedMessage.message } linkStyle={ errorData.taggedMessage.linkStyle }/>;
  } else {
    return errorData?.message;
  }

};
